export default __webpack_public_path__ + "static/media/SOUTH AMERICA.17c5e9ba.svg";